"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Text = _interopRequireDefault(require("../Text"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Price = _interopRequireDefault(require("../Price"));

var _BaggageHeader = _interopRequireDefault(require("../BaggageHeader"));

var _baggageSection = _interopRequireDefault(require("./baggageSection.proptypes"));

var _constant = require("./constant");

var _SegementByWeight = _interopRequireDefault(require("./SegementByWeight"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var BaggageSectionWrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageSectionWrapper",
  componentId: "sc-wh704n-0"
})(["display:flex;flex-direction:column;"]);

var MainContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__MainContainer",
  componentId: "sc-wh704n-1"
})([""]);

var BaggageCategory = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageCategory",
  componentId: "sc-wh704n-2"
})([""]);

var BaggageSegement = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageSegement",
  componentId: "sc-wh704n-3"
})(["background-color:", ";padding:", ";border-bottom:", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
}, function (_ref2) {
  var theme = _ref2.theme,
      isMobile = _ref2.isMobile;
  return isMobile ? "".concat(theme.space.small, " ").concat(theme.space.XSmall) : "".concat(theme.space.XSmall, " ").concat(theme.space.semi, " ").concat(theme.space.XSmall, " ").concat(theme.space.small);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.colors.greyLight);
}, function (_ref4) {
  var isLastSegment = _ref4.isLastSegment,
      theme = _ref4.theme;
  return isLastSegment ? "0px 0px ".concat(theme.space.micro, " ").concat(theme.space.micro) : "0px";
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__Wrapper",
  componentId: "sc-wh704n-4"
})(["display:flex;flex-flow:row wrap;flex:1;"]);

var CheckBoxContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__CheckBoxContainer",
  componentId: "sc-wh704n-5"
})([""]);

var SummaryContainer = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__SummaryContainer",
  componentId: "sc-wh704n-6"
})(["display:flex;flex-direction:column;flex:", ";"], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 3 : 3;
});

var TitleDimensionWrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__TitleDimensionWrapper",
  componentId: "sc-wh704n-7"
})(["display:flex;flex-direction:", ";margin-bottom:", ";"], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? 'column' : 'row';
}, function (_ref7) {
  var theme = _ref7.theme,
      isLast = _ref7.isLast;
  return isLast ? theme.space.none : theme.space.micro;
});

var BaggageTitle = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageTitle",
  componentId: "sc-wh704n-8"
})(["display:flex;flex-direction:row;"]);

var BaggageInfo = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageInfo",
  componentId: "sc-wh704n-9"
})(["display:flex;flex-flow:column wrap;flex:2;"]);

var BaggageDimension = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggageDimension",
  componentId: "sc-wh704n-10"
})(["margin-left:", ";flex:1;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.standard;
});

var BaggagePrice = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__BaggagePrice",
  componentId: "sc-wh704n-11"
})(["display:flex;justify-content:flex-end;flex:", ";"], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? 2 : 2;
});

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__IconWrapper",
  componentId: "sc-wh704n-12"
})(["display:flex;align-items:flex-start;justify-content:center;"]);

var Included = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__Included",
  componentId: "sc-wh704n-13"
})([""]);

var StatusMessage = _styledComponents.default.div.withConfig({
  displayName: "BaggageSection__StatusMessage",
  componentId: "sc-wh704n-14"
})(["background-color:", ";border-radius:", ";padding:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.tertiaryLight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadius.normal;
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.micro, " ").concat(theme.space.mini, " ").concat(theme.space.micro);
});

var BaggageSection = function BaggageSection(props) {
  var accessible = props.accessible,
      theme = props.theme,
      baggageData = props.baggageData,
      isMobile = props.isMobile,
      selectedBaggage = props.selectedBaggage,
      onBaggageSelection = props.onBaggageSelection,
      translation = props.translation,
      type = props.type,
      selectorIndex = props.selectorIndex,
      isReturnFlight = props.isReturnFlight,
      allowBaggageUpgrade = props.allowBaggageUpgrade,
      showUpsellBanner = props.showUpsellBanner,
      upsellBannerConfig = props.upsellBannerConfig,
      isOnePaxView = props.isOnePaxView;

  var _React$useState = _react.default.useState(isOnePaxView),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      showSportsEquip = _React$useState2[0],
      setShowSportsEquip = _React$useState2[1];

  var _React$useState3 = _react.default.useState(selectedBaggage),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      optionSelected = _React$useState4[0],
      setOptionSelected = _React$useState4[1];

  var baggageArr = baggageData;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var getTitle = function getTitle(title, baggageType, idx) {
    return /*#__PURE__*/_react.default.createElement(BaggageTitle, {
      key: "".concat(baggageType, "_").concat(title, "_").concat(idx)
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: _constant.BAGGAGE_ICONS[baggageType].color,
      fontsize: _constant.BAGGAGE_ICONS[baggageType].size,
      icon: _constant.BAGGAGE_ICONS[baggageType].type
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: _constant.TEXT_TYPE.HEADING.type,
      bold: true,
      color: _constant.TEXT_TYPE.HEADING.color,
      marginLeft: "micro",
      tag: _constant.TAG.div
    }, title));
  };

  var getDimension = function getDimension(dimension) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      type: isMobile ? _constant.TEXT_TYPE.MOBILE_DESC.type : _constant.TEXT_TYPE.DESC.type,
      color: isMobile ? _constant.TEXT_TYPE.MOBILE_DESC.color : _constant.TEXT_TYPE.DESC.color,
      tag: _constant.TAG.div
    }, dimension);
  };

  var getSummary = function getSummary(title, baggageType) {
    return /*#__PURE__*/_react.default.createElement(SummaryContainer, {
      isMobile: isMobile
    }, title.map(function (_ref13, idx) {
      var weight = _ref13.weight,
          dimension = _ref13.dimension;
      var baggageTitle = "".concat(weight, " ").concat(language[baggageType]);
      var keyIndex = "idx_".concat(idx);
      var isLast = idx === title.length - 1;
      return /*#__PURE__*/_react.default.createElement(TitleDimensionWrapper, {
        isMobile: isMobile,
        isLast: isLast,
        key: "".concat(baggageType, "_").concat(weight, "_").concat(dimension, "_").concat(keyIndex)
      }, /*#__PURE__*/_react.default.createElement(BaggageInfo, null, getTitle(baggageTitle, baggageType, idx)), /*#__PURE__*/_react.default.createElement(BaggageDimension, {
        isMobile: isMobile
      }, getDimension(dimension)));
    }));
  };

  var getPrice = function getPrice(amount, currency) {
    return /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: amount,
      color: _constant.PRICE_TEXT_TYPE.normal.color,
      customFontSize: _constant.PRICE_TEXT_TYPE.normal.fontSize,
      customCurrencySize: _constant.PRICE_TEXT_TYPE.normal.currencySize,
      currency: currency,
      allowLocaleFormat: true,
      noDecimalValues: false,
      customProperties: {
        customCurrencyColor: 'greyDarker'
      }
    });
  };

  var getIncludedText = function getIncludedText() {
    return /*#__PURE__*/_react.default.createElement(StatusMessage, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      theme: theme,
      bold: true,
      type: _constant.TEXT_TYPE.STATUS.type,
      color: _constant.TEXT_TYPE.STATUS.color,
      tag: _constant.TAG.span,
      customProperties: {
        fontWeight: _constant.TEXT_TYPE.STATUS.fontWeight
      }
    }, language.included));
  };

  var isThisBaggageOptionAlreadySelected = function isThisBaggageOptionAlreadySelected(currBaggageSegIndex, baggageType) {
    return selectedBaggage[baggageType] && selectedBaggage[baggageType].selectedIndex === currBaggageSegIndex;
  };

  var baggageSelectHandler = function baggageSelectHandler(segData, currBaggageSegIndex, baggageType) {
    var check = isThisBaggageOptionAlreadySelected(currBaggageSegIndex, baggageType);

    var newSelectedBaggage = _objectSpread(_objectSpread({}, selectedBaggage), (0, _defineProperty2.default)({}, baggageType, check ? {
      selectedIndex: -1,
      segData: {}
    } : {
      selectedIndex: currBaggageSegIndex,
      segData: segData
    }));

    onBaggageSelection(newSelectedBaggage);
  };

  var getBaggageSegment = function getBaggageSegment(segData, currBaggageSegIndex, baggageType, isLastSegment) {
    var title = segData.title,
        currency = segData.currency,
        amount = segData.amount,
        isPreSelected = segData.isPreSelected;
    var uniqueKey = title.map(function (_ref14) {
      var weight = _ref14.weight,
          dimension = _ref14.dimension;
      return "".concat(weight, "_").concat(dimension);
    }).join('_');
    var isBaggageSelected = isThisBaggageOptionAlreadySelected(currBaggageSegIndex, baggageType);
    var isAllowedUpgrade = allowBaggageUpgrade ? isBaggageSelected : !isBaggageSelected;

    if (isPreSelected && isAllowedUpgrade) {
      baggageSelectHandler(segData, currBaggageSegIndex, baggageType);
    }

    return /*#__PURE__*/_react.default.createElement(BaggageSegement, (0, _extends2.default)({}, !isPreSelected && {
      onClick: function onClick() {
        return baggageSelectHandler(segData, currBaggageSegIndex, baggageType);
      }
    }, {
      key: "".concat(baggageType, "_").concat(uniqueKey),
      isMobile: isMobile,
      isLastSegment: isLastSegment
    }), /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(CheckBoxContainer, null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({
      theme: theme,
      accessible: accessible,
      disableBottomMargin: true
    }, isPreSelected && {
      disableCheckbox: true,
      disabledWithSelected: true,
      isSelected: false
    }, !isPreSelected && {
      isSelected: isBaggageSelected
    }))), getSummary(title, baggageType), /*#__PURE__*/_react.default.createElement(BaggagePrice, {
      isMobile: isMobile
    }, isPreSelected ? /*#__PURE__*/_react.default.createElement(Included, null, getIncludedText()) : getPrice(amount, currency))));
  };

  var getBaggageHeader = function getBaggageHeader(baggageObj) {
    var baggageType = baggageObj.baggageType,
        baggageTypeColor = baggageObj.baggageTypeColor,
        baggageHeadingColor = baggageObj.baggageHeadingColor,
        showToolTip = baggageObj.showToolTip,
        toolTipColor = baggageObj.toolTipColor,
        customToolTipContent = baggageObj.customToolTipContent,
        toolTipContent = baggageObj.toolTipContent,
        toolTipTitle = baggageObj.toolTipTitle;
    return /*#__PURE__*/_react.default.createElement(_BaggageHeader.default, {
      theme: theme,
      accessible: accessible,
      baggageType: baggageType,
      baggageTypeColor: baggageTypeColor,
      baggageHeadingColor: baggageHeadingColor,
      showToolTip: showToolTip,
      toolTipColor: toolTipColor,
      isMobile: isMobile,
      translation: _objectSpread(_objectSpread({}, translation), {}, {
        toolTipLabel: translation["".concat(baggageType, "ToolTipLabel")],
        toolTipTitle: translation["".concat(baggageType, "ToolTipTitle")]
      }),
      customToolTipContent: customToolTipContent,
      toolTipContent: toolTipContent,
      toolTipTitle: toolTipTitle
    });
  };

  var showHeader = function showHeader(baggageList, baggageType) {
    if (baggageList.length > 0) {
      if (baggageType !== _constant.BAGGAGE_TYPES.sportsEquip || type !== _constant.segmentType.segmentByWeight) return true;
      if (baggageType === _constant.BAGGAGE_TYPES.sportsEquip && showSportsEquip) return true;
    }

    return false;
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(BaggageSectionWrapper, {
      tabIndex: tabIndex,
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(MainContainer, null, baggageArr.map(function (baggageObj, objIndex) {
      var baggageType = baggageObj.baggageType,
          baggageList = baggageObj.baggageList;
      var index = "".concat(isReturnFlight, ".").concat(selectorIndex, ".").concat(objIndex);
      return /*#__PURE__*/_react.default.createElement(BaggageCategory, {
        key: baggageType,
        id: "".concat(baggageType, "-").concat(index)
      }, showHeader(baggageList, baggageType) && getBaggageHeader(baggageObj), type !== _constant.segmentType.segmentByWeight ? baggageList.map(function (segData, segIndex) {
        var isLastSegment = objIndex === baggageArr.length - 1 && segIndex === baggageList.length - 1;
        return getBaggageSegment(segData, segIndex, baggageType, isLastSegment);
      }) : /*#__PURE__*/_react.default.createElement(_SegementByWeight.default, {
        objIndex: index,
        baggageList: baggageList,
        theme: theme,
        baggageType: baggageType,
        translation: translation,
        showSportsEquip: showSportsEquip,
        setShowSportsEquip: setShowSportsEquip,
        getPrice: getPrice,
        optionSelected: optionSelected,
        setOptionSelected: setOptionSelected,
        onBaggageSelection: onBaggageSelection,
        isMobile: isMobile,
        showUpsellBanner: showUpsellBanner,
        upsellBannerConfig: upsellBannerConfig,
        isOnePaxView: isOnePaxView
      }));
    })));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

BaggageSection.propTypes = _baggageSection.default.PropTypes;
BaggageSection.defaultProps = _baggageSection.default.DefaultProps;

var _default = /*#__PURE__*/_react.default.memo(BaggageSection);

exports.default = _default;